let connectedAccountAddress: null | string = null

export const getPolymarketConnectedAccountAddress = () =>
  connectedAccountAddress

export function setPolymarketConnectedAccountAddress(address: null | string) {
  connectedAccountAddress = address
}
